import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { normalize, schema } from "normalizr";

import { showError } from "../../utils/sagasErrorHandler";

import { requestLanguages } from "./api";
import { languagesSelector } from "./selectors";
import { getLanguages, setLanguages } from "./actions";


const languagesSchema = new schema.Entity("languages" , {},{ idAttribute: "iso_code2" });
const languageListSchema = new schema.Array(languagesSchema);

export function* getLanguagesWorker() {
    try {
        const { codes } = yield select(languagesSelector);

        if(!codes.length){
            yield put(setLanguages({ isLoadingLanguages: true }));

            const { languages } = yield call(requestLanguages);
            const { result, entities } = normalize(languages, languageListSchema);

            yield put(getLanguages({
                isLoadingLanguages: false,
                languages: entities.languages,
                codes: result
            }));
        }
    } catch (error) {
        yield put(setLanguages({ isLoadingLanguages: false }));
        showError(error);
    }
}

export function* getLanguagesSaga() {
    yield all([
        yield takeLatest(getLanguages, getLanguagesWorker)
    ]);
}
